/**
 * @format
 */

import {AppRegistry} from 'react-native';
import App from './web/App';
import {name as appName} from './app.json';

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
    rootTag: document.getElementById('root'),
});
